import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import News from './pages/News';
import Players from './pages/Players';
import Teams from './pages/Teams';
import Clubs from './pages/Clubs';
import ClubCalendar from './pages/ClubCalendar';
import Fixtures from './pages/Fixtures';
import FixtureDetail from './pages/FixtureDetail';
import TeamStandings from './pages/TeamStandings';
import PlayerRankings from './pages/PlayerRankings';
import Cup from './pages/Cup';
import Seasons from './pages/Seasons';
import ActivityLog from './pages/ActivityLog';
import { DivisionProvider } from './context/DivisionContext';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ToastViewport from './components/ToastViewport';
import BuildInfoWidget from './components/BuildInfoWidget';

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    axios.post('/api/track', { path: location.pathname }).catch(() => {});
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <DivisionProvider>
          <div className="min-h-screen bg-gray-50">
            <RouteTracker />
            <Navbar />
            <main className="container mx-auto px-4 py-8 pb-16">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/news" element={<News />} />
                <Route path="/players" element={<Players />} />
                <Route path="/teams" element={<Teams />} />
                <Route path="/clubs" element={<Clubs />} />
                <Route path="/clubs/:clubId/calendar" element={<ClubCalendar />} />
                <Route path="/fixtures" element={<Fixtures />} />
                <Route path="/fixtures/:id" element={<FixtureDetail />} />
                <Route path="/team-standings" element={<TeamStandings />} />
                <Route path="/cup" element={<Cup />} />
                <Route path="/player-rankings" element={<PlayerRankings />} />
                <Route path="/seasons" element={<Seasons />} />
                <Route path="/activity" element={<ActivityLog />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <footer className="fixed bottom-4 left-4 z-40 rounded-full border border-gray-200 bg-white/90 px-3 py-1 text-xs font-medium text-gray-700 shadow-sm">
              Created by Alexey Reutov
            </footer>
            <ToastViewport />
            <BuildInfoWidget />
          </div>
        </DivisionProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
